import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoDocumento } from '../models/projeto-documentos.model';

@Injectable({
  providedIn: 'root',
})
export class ProjetoDocumentoService extends BaseService<ProjetoDocumento> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-documentos';
  }

  public updateDocumento(obj, id: number): Observable<any> {
    return this.http.post<ProjetoDocumento>(this.baseUrl + '/' + id, obj);
  }

  public createDocumento(obj): Observable<ProjetoDocumento> {
    return this.http.post<ProjetoDocumento>(this.baseUrl, obj);
  }

  public getListFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-filters', { headers: this.headers });
  }

  public getListAllCron(id: number): Observable<ProjetoDocumento[]> {
    return this.http.get<ProjetoDocumento[]>(this.baseUrl + '/list-cronograma/' + id, { headers: this.headers });
  }

  public download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + id, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }

  extractFilename(contentDispositionHeader: string): string | null {
    const matches = contentDispositionHeader.match(/filename\*=(?:UTF-8['']?)?([^;\r\n]*)/i);
    if (matches && matches.length > 1) {
      let encodedFilename = matches[1].trim();
      return decodeURIComponent(encodedFilename);
    }
    return null;
  }
}
